// Pure slot maths for the availability search. No React, no dayjs, no side effects.

import type { DayResults, SlotOption } from './ehrAppointmentV2.types'

export const slotKey = (slot: SlotOption): string => `${slot.day}-${slot.start}-${slot.end}`

export const groupByDay = (slots: readonly SlotOption[]): DayResults[] => {
  const days = slots.reduce<Record<string, SlotOption[]>>((groups, slot) => {
    const current = groups[slot.day] ?? []
    return { ...groups, [slot.day]: [...current, slot] }
  }, {})

  return Object.keys(days)
    .sort()
    .map((day) => ({
      day,
      label: formatDayLabel(day),
      options: [...days[day]].sort((left, right) => left.start - right.start),
      total: days[day].length,
    }))
}

export const formatMinutes = (minutes: number): string => {
  const hours24 = Math.floor(minutes / 60) % 24
  const rest = minutes % 60
  const suffix = hours24 >= 12 ? 'PM' : 'AM'
  const hours = hours24 % 12 || 12
  return `${hours}:${String(rest).padStart(2, '0')} ${suffix}`
}

export const formatDuration = (minutes: number): string => {
  if (minutes < 60) return `${minutes} min`
  const hours = minutes / 60
  return `${Number.isInteger(hours) ? hours : hours.toFixed(1)} hr`
}

// "2026-09-21" without going through a timezone aware parser.
export const formatDayLabel = (day: string): string => {
  const [year, month, date] = day.split('-').map(Number)
  if (!year || !month || !date) return day

  return new Date(year, month - 1, date).toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  })
}

export const minutesFromDate = (value: Date): number => value.getHours() * 60 + value.getMinutes()
